import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './central-heating.reducer';

export const CentralHeatingUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const centralHeatingEntity = useAppSelector(state => state.centralHeating.entity);
  const loading = useAppSelector(state => state.centralHeating.loading);
  const updating = useAppSelector(state => state.centralHeating.updating);
  const updateSuccess = useAppSelector(state => state.centralHeating.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/central-heating${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllHouseholds !== undefined && typeof values.totalAllHouseholds !== 'number') {
      values.totalAllHouseholds = Number(values.totalAllHouseholds);
    }
    if (values.gasCentralHeating !== undefined && typeof values.gasCentralHeating !== 'number') {
      values.gasCentralHeating = Number(values.gasCentralHeating);
    }
    if (values.electricCentralHeating !== undefined && typeof values.electricCentralHeating !== 'number') {
      values.electricCentralHeating = Number(values.electricCentralHeating);
    }
    if (values.oilCentralHeating !== undefined && typeof values.oilCentralHeating !== 'number') {
      values.oilCentralHeating = Number(values.oilCentralHeating);
    }
    if (values.solidFuelCentralHeating !== undefined && typeof values.solidFuelCentralHeating !== 'number') {
      values.solidFuelCentralHeating = Number(values.solidFuelCentralHeating);
    }
    if (values.otherCentralHeating !== undefined && typeof values.otherCentralHeating !== 'number') {
      values.otherCentralHeating = Number(values.otherCentralHeating);
    }
    if (values.noCentralHeating !== undefined && typeof values.noCentralHeating !== 'number') {
      values.noCentralHeating = Number(values.noCentralHeating);
    }

    const entity = {
      ...centralHeatingEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...centralHeatingEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.centralHeating.home.createOrEditLabel" data-cy="CentralHeatingCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.centralHeating.home.createOrEditLabel">Create or edit a CentralHeating</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="central-heating-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.centralHeating.geographicLevel')}
                id="central-heating-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.centralHeating.date')}
                id="central-heating-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.centralHeating.geography')}
                id="central-heating-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.centralHeating.geographyCode')}
                id="central-heating-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.centralHeating.totalAllHouseholds')}
                id="central-heating-totalAllHouseholds"
                name="totalAllHouseholds"
                data-cy="totalAllHouseholds"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.centralHeating.gasCentralHeating')}
                id="central-heating-gasCentralHeating"
                name="gasCentralHeating"
                data-cy="gasCentralHeating"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.centralHeating.electricCentralHeating')}
                id="central-heating-electricCentralHeating"
                name="electricCentralHeating"
                data-cy="electricCentralHeating"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.centralHeating.oilCentralHeating')}
                id="central-heating-oilCentralHeating"
                name="oilCentralHeating"
                data-cy="oilCentralHeating"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.centralHeating.solidFuelCentralHeating')}
                id="central-heating-solidFuelCentralHeating"
                name="solidFuelCentralHeating"
                data-cy="solidFuelCentralHeating"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.centralHeating.otherCentralHeating')}
                id="central-heating-otherCentralHeating"
                name="otherCentralHeating"
                data-cy="otherCentralHeating"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.centralHeating.noCentralHeating')}
                id="central-heating-noCentralHeating"
                name="noCentralHeating"
                data-cy="noCentralHeating"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/central-heating" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CentralHeatingUpdate;
